import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const AlarmTypesContent = ({ data }) => {
    const type = data?.apply?.alarms_type;

    useEffect(() => {
        const values = [];
        const labels = [];

        type.map((element) => {
           labels.push(element.text);
           values.push(element.qty);
        });

        GraphicUtils.horizontalStackedBarChart(type, "alarm-type", "text");
        ReportUtils.createExportableTable(labels, values, "Tipos de alarmes");
    }, [type]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Tipos de alarmes</span>
                <div className="mt-1" id="alarm-type"/>
            </div>

            <div className="chart-divisor"/>
        </>
    );
};

export default AlarmTypesContent;